import React, { useState, useEffect } from 'react'
import { getFirestore, collection, getDocs } from '@firebase/firestore'
import { app } from '../../firebase.js'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

function CountryAnalysis() {
  const db = getFirestore(app)
  const [tableData, setTableData] = useState([])
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true

    const fetchData = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'users'))
        const grouped = {}
        const courseTotals = {}

        snapshot.forEach((doc) => {
          const u = doc.data()
          if (u.userType !== 'student') return

          const nationality = (u.nationality || 'Unknown').trim()
          const course = (u.course || 'Unspecified').trim()

          if (!grouped[nationality]) grouped[nationality] = { nationality, total: 0 }

          grouped[nationality][course] = (grouped[nationality][course] || 0) + 1
          grouped[nationality].total += 1

          courseTotals[course] = (courseTotals[course] || 0) + 1
        })

        // order courses by overall popularity
        const courseList = Object.keys(courseTotals).sort((a, b) => courseTotals[b] - courseTotals[a])

        // convert grouped object to array and sort nationalities by total desc
        const dataArray = Object.values(grouped).sort((a, b) => b.total - a.total)

        if (mounted) {
          setCourses(courseList)
          setTableData(dataArray)
          setLoading(false)
        }
      } catch (err) {
        console.error('CountryAnalysis fetch error', err)
      }
    }

    fetchData()
    return () => {
      mounted = false
    }


  }, [db])

  if (loading) return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <div className="p-4">
          <p>Loading...</p>
        </div>
      </div>
    </div>
  )

  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <div className="p-4">
          <h4>Nationality vs Course Choice</h4>

          <h5 className="mt-4">Table: counts by nationality and course</h5>
          <div style={{ overflowX: 'auto' }}>
            <Table striped bordered hover className="mt-2">
              <thead>
                <tr>
                  <th>Nationality</th>
                  {courses.map((c) => (
                    <th key={c}>{c}</th>
                  ))}
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row) => (
                  <tr key={row.nationality}>
                    <td>{row.nationality}</td>
                    {courses.map((c) => (
                      <td key={c}>{row[c] || 0}</td>
                    ))}
                    <td>{row.total}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>


  )
}

export default CountryAnalysis